import React, { FC } from 'react';
import { Text } from '@blueprint/ui';
import {
    ButtonForm,
    BulletColor,
    AlertModalHeading,
    AlertModalSubHeading,
    AlertContextText,
    AlertModalOptions,
    HorizontalDivider,
    Container,
    AlertModalName,
    ModalBody
} from './AlertModal.styles';

const AlertModal: FC<{
    isShowing: boolean;
    close: () => void;
}> = ({ isShowing, close }) => {
    return (
        <ModalBody isShowing={isShowing} close={close}>
            <Container>
                <HorizontalDivider variant="horizontal" />
                <AlertModalHeading size="5">Alexandra Palace</AlertModalHeading>
                <BulletColor>
                    <li>Flats for sale</li>
                    <li>Between £350,000 and £450,000</li>
                    <li>Between 2 and 4 bedrooms</li>
                </BulletColor>
                <AlertModalSubHeading size="7">
                    Set the frequency
                </AlertModalSubHeading>
                <AlertContextText size="secondary" color="grey-slate">
                    Choose how often you&apos;d like to hear about new
                    properties on the market.
                </AlertContextText>
                <AlertModalOptions
                    id="boxed-option-1"
                    label="No email alerts"
                    name="boxed-option"
                    variant="boxed"
                />
                <AlertModalOptions
                    id="boxed-option-2"
                    label="Instant"
                    name="boxed-option"
                    variant="boxed"
                />

                <AlertModalOptions
                    id="boxed-option-3"
                    label="Daily"
                    name="boxed-option"
                    variant="boxed"
                />

                <AlertModalOptions
                    id="boxed-option-4"
                    label="Every 3 days"
                    name="boxed-option"
                    variant="boxed"
                />

                <AlertModalOptions
                    id="boxed-option-5"
                    label="Weekly"
                    name="boxed-option"
                    variant="boxed"
                />

                <Text size="small" color="grey-steel">
                    You can always adjust the frequency of alerts in MyZoopla
                </Text>

                <AlertModalSubHeading size="7">
                    Manage alerts and searches
                </AlertModalSubHeading>

                <AlertModalName
                    id="field-nickname"
                    label="Give this alert a nickname"
                    name="name-nickname"
                />

                <ButtonForm variant="primary">Save</ButtonForm>
            </Container>
        </ModalBody>
    );
};

export default AlertModal;
